export default "# Education\n\n- #### B.Tech, Instrumentation & Control Engineering @ [NIT Trichy](https://www.nitt.edu/)\n"